// frontend/src/modules/onboarding/api.ts

import { api } from '../../core/api-client';
import type { OnboardingState } from './types';

export const onboardingApi = {
  get: () => api<OnboardingState>('/api/onboarding'),
  /** Report that the first-run walkthrough actually opened — this, not the GET,
   * consumes the one-shot auto-open flag. */
  firstRunSeen: () => api<{ ok: boolean }>('/api/onboarding/first-run-seen', { method: 'POST' }),
  skip: () => api<{ ok: boolean }>('/api/onboarding/skip', { method: 'POST' }),
  resume: () => api<{ ok: boolean }>('/api/onboarding/resume', { method: 'POST' }),
  complete: () => api<{ ok: boolean }>('/api/onboarding/complete', { method: 'POST' }),
  dismissStep: (key: string) =>
    api<{ ok: boolean }>(`/api/onboarding/steps/${encodeURIComponent(key)}/dismiss`, { method: 'POST' }),
};
